/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface PersonPhoneRef
 */
export interface PersonPhoneRefOptional {
  /**
   *
   * @type {number}
   * @memberof PersonPhoneRef
   */
  personPhoneAssignId?: number;
}

export interface PersonPhoneRef extends PersonPhoneRefOptional {
  /**
   *
   * @type {number}
   * @memberof PersonPhoneRef
   */
  personPhoneAssignId: number;
}

export interface PersonPhoneRefTrackedI {
  /**
   *
   * @type {number}
   * @memberof PersonPhoneRef
   */
  personPhoneAssignId?: number;
  personPhoneAssignIdIsSet: boolean;
}

transformDatesMap.set("PersonPhoneRef", function (model: PersonPhoneRef) {});

export type PersonPhoneRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  personPhoneAssignId: PropertyMeta<MetaTypeBase<number>>;
}>;

export var PersonPhoneRefMeta: PersonPhoneRefMetaI = {} as PersonPhoneRefMetaI;
PersonPhoneRefMeta = typeMeta("PersonPhoneRef", {
  personPhoneAssignId: propertyMeta(
    "personPhoneAssignId",
    false,
    true,
    true,
    MetaTypesBase.number,
  ),
});

const metaI = PersonPhoneRefMeta;

registerMeta(() => {});

export class PersonPhoneRefTracked implements PersonPhoneRefTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  personPhoneAssignId__I?: number = undefined;

  get personPhoneAssignIdIsSet() {
    return this.personPhoneAssignId !== undefined;
  }
  set personPhoneAssignIdIsSet(v: boolean) {}
  set personPhoneAssignId(v: undefined | number) {
    if (v !== undefined) {
      this.personPhoneAssignId__I = v;
      this.personPhoneAssignIdIsSet = true;
    } else {
      this.personPhoneAssignId__I = v || undefined;
      this.personPhoneAssignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personPhoneAssignId() {
    return this.personPhoneAssignId__I;
  }
  constructor(config?: PersonPhoneRefOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (
      this.personPhoneAssignIdIsSet == true &&
      other?.personPhoneAssignIdIsSet == true
    )
      return this.personPhoneAssignId == other.personPhoneAssignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.personPhoneAssignId) {
      this.personPhoneAssignIdIsSet = true;
    }
  }
  assignFrom(
    config: PersonPhoneRefOptional,
    options?: AssignOptions,
  ): PersonPhoneRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.personPhoneAssignId &&
      this.personPhoneAssignIdApplyFilter(optionsRequired.filter)
    ) {
      this.personPhoneAssignId = config.personPhoneAssignId;
      if (optionsRequired.unassign) this.personPhoneAssignIdIsSet = false;
      else this.personPhoneAssignIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonPhoneRefTrackedI {
    const cloned = {} as PersonPhoneRefTrackedI;
    if (
      this.personPhoneAssignIdIsSetDeep() &&
      this.personPhoneAssignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personPhoneAssignIdIsSet = true;
      cloned.personPhoneAssignId = this.personPhoneAssignId;
    } else {
      //cloned.personPhoneAssignIdIsSet = false
    }
    if (!isDeleted(this) && !this.personPhoneAssignIdIsSet)
      updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonPhoneRefTrackedI {
    if (!this.personPhoneAssignIdApplyFilter(filter))
      this.personPhoneAssignIdIsSet = false;

    return this;
  }
  personPhoneAssignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPhoneRefMeta.personPhoneAssignId,
      PersonPhoneRefMeta,
      this.personPhoneAssignId,
      this,
    );
  }
  personPhoneAssignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.personPhoneAssignIdIsSet &&
      this.personPhoneAssignIdApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.personPhoneAssignIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
